export default "__VITE_ASSET__4khKmRl9__"